import TitleHeader from '../../atoms/TitleHeader/TitleHeader'
import Constants from '../../../app/utils/constants'
import { motion, Variants } from "framer-motion"
import './ExpertTeam.css'

const ExpertTeam = () => {
const { expertTeam } = Constants
const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
}

const cardVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.75,
    y: 40,
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

  return (
    <section className="w-full px-4 pb-14 sm:px-6 md:px-10 lg:px-16 lg:pb-20">
      <div className="mx-auto w-full max-w-8xl ">
        
        {/* HEADER */}
        <div className="mb-10 flex flex-col items-center justify-center">
          <TitleHeader
            badgeText="OUR TEAM"
            titleLines={['Our Engineering Team']}
            wrapperClassName="w-full max-w-4xl flex flex-col items-center text-center"
            titleClassName="text-4xl md:text-5xl font-rajdhani font-semibold text-center"
            badgeClassName="text-xl md:text-2xl px-8 md:px-10 py-2.5 md:py-3.5"
          />
          <p className="max-w-5xl text-center font-gilroy text-base leading-relaxed text-gray-300 md:text-lg lg:text-2xl">
            We are selective about who joins TheCoding Studio. Every engineer on our team brings a
            minimum of 3 years of production experience. No fresh graduates learning on client
            projects. No offshore staffing games. Just practitioners who have built, shipped, and
            maintained systems that matter.
          </p>
        </div>

        {/* GRID WITH ANIMATION */}
        <motion.div
          className="mx-auto max-w-[1600px] grid w-full grid-cols-2 justify-items-center gap-y-4 md:gap-6 md:grid-cols-3 lg:grid-cols-4 lg:gap-8 min-[2560px]:gap-12"
        >
          {expertTeam.map((member, idx) => (
            
            <motion.div
            key={`${member.name}-${idx}`}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.1 }}
            className="expert-card-wrapper group h-[99%] w-[85%] shrink-0 md:h-[320px] md:w-[200px] xl:h-[400px] xl:w-[270px] 2xl:h-[500px] 2xl:w-[330px] min-[2560px]:h-[760px] min-[2560px]:w-[420px]"
          >
              <div
                className="expert-card-inner relative h-full w-full overflow-hidden"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="h-full w-full object-cover"
                />

                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    height: '50%',
                    background: 'linear-gradient(360deg, #261469 0%, rgba(116, 77, 255, 0) 100%)',
                  }}
                />

                <div
                  className="absolute text-center inset-x-0 bottom-0 origin-bottom scale-y-0 transition-transform duration-[2000ms] ease-in-out group-hover:scale-y-100"
                  style={{
                    height: '50%',
                    background: 'linear-gradient(360deg, #744DFF 0%, rgba(116, 77, 255, 0) 100%)',
                  }}
                />

                <div className="absolute inset-x-0 bottom-0 pt-7 pb-4 md:px-6 md:pb-8 md:pt-16 text-center min-[2560px]:pb-12">
                  <h4 className="font-rajdhani text-base font-semibold text-white md:text-xl xl:text-2xl min-[2560px]:text-3xl">
  {member.name}
</h4>

<h6 className="font-gilroy mx-auto text-xs w-[60%] md:w-full text-gray-200 md:text-sm xl:text-sm min-[2560px]:text-lg">
  {member.role}
</h6>
                </div>
              </div>
            </motion.div>

          ))}
        </motion.div>

      </div>
    </section>
  )
}

export default ExpertTeam
